import { Container, IconButton, Typography } from "@material-ui/core"
import { GeneralLinks } from "common/SiteLinks"
import NextLink from "components/Reusable/Bit/NextLink"
import Header from "layout/Header"
import { useRouter } from "next/router"
import styled from "styled-components"
import BackIcon from "../Icons/BackIcon"

const StyledContainer = styled(Container)`
  margin-top: 80px;
  height: 100%;
  padding: 26px 60px;

  ${(p) => p.theme.breakpoints.up("md")} {
    min-height: 600px;
  }
`

const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  p {
    margin-right: 8px;
  }

  :hover {
    text-decoration: underline;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  text-align: right;
  margin-top: 25px;
  font-size: 50px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 40px;
  }
`

const StyledContentContainer = styled.div`
  margin-top: 20px;
  display: flex;
  overflow: wrap;
`

const StyledColumn = styled.div`
  margin-left: 80px;
`

const StyledLinkText = styled(Typography).attrs({ variant: "body1" })`
  font-size: 20px;
  line-height: 24px;
  padding-bottom: 20px;
  text-align: right;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 22px;
  }

  :hover {
    text-decoration: underline;
  }
`

const StyledColumnTitle = styled(Typography).attrs({ variant: "h4" })`
  text-align: right;
  height: 28px;
`

const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 20px;

  ${(p) => p.theme.breakpoints.up("md")} {
    max-height: 380px;
  }
`

const StyledLinkList = styled.div`
  margin-top: 20px;
`

const StyledListItem = styled(Typography).attrs({ variant: "body1" })`
  text-align: right;
  display: block;
  margin-left: 80px;
  padding-bottom: 20px;
  font-size: 20px;
  line-height: 24px;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 22px;
  }

  :hover {
    text-decoration: underline;
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

const StyledListContainer = styled.div``

const SiteMapPage = ({ categories }) => {
  const router = useRouter()

  return (
    <>
      <Header />
      <StyledContainer>
        <StyledLink onClick={() => router.back()}>
          <StyledIconBtn>
            <BackIcon />
          </StyledIconBtn>
          <Typography variant="body1">חזרה</Typography>
        </StyledLink>

        <StyledTitle>מפת אתר</StyledTitle>
        <StyledContentContainer>
          <StyledColumn>
            <StyledColumnTitle>כללי</StyledColumnTitle>
            <StyledLinkList>
              {GeneralLinks.map((item, i) => (
                <NextLink
                  href={item?.link}
                  key={`${item} + ${i}`}
                  openInNewTab={item.blank}
                >
                  <StyledLinkText>{item.title}</StyledLinkText>
                </NextLink>
              ))}
            </StyledLinkList>
          </StyledColumn>

          <StyledListContainer>
            <StyledColumnTitle>קטגוריות</StyledColumnTitle>
            <StyledList>
              {categories.map((category, j) => {
                if (category?.name === "הכי פופולרי") return
                return (
                  <NextLink
                    href={`/category/${category?.slug || ""}`}
                    key={`${category}${j}`}
                  >
                    <StyledListItem>{category.name}</StyledListItem>
                  </NextLink>
                )
              })}
            </StyledList>
          </StyledListContainer>
        </StyledContentContainer>
      </StyledContainer>
    </>
  )
}

export default SiteMapPage
